import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import FontAwesome from 'react-fontawesome';
import logo from './vexpo-logo.svg';
import './auth.css';

/** @class Auth
  * A component that ensures a user is authenticated
  * with Firebase Auth before displaying any child content.
  */
export default class Auth extends Component {
  /** @constructor
    * Creates a new instance of Auth
    */
  constructor(props) {
    super(props);
    this.state = { email:'', user: null, alert: "" }
    this.handleChange = this.handleChange.bind(this);
    this.handleLinkRequest = this.handleLinkRequest.bind(this);
    this.attemptLogin = this.attemptLogin.bind(this);
    if(!window.vexpo) window.vexpo = {};
    window.vexpo.user = {};
  }
  /** @method handleLinkRequest
    * Responds to a user request for a new login link
    * by sending an link via supplied email.
    */
  handleLinkRequest(event) {
    event.preventDefault();
    const actionCodeSettings = {
      url: `${window.location.protocol}//${window.location.host}/#/${window.location.hash}`,
      handleCodeInApp: true
    }
    firebase.auth()
      .sendSignInLinkToEmail(this.state.email, actionCodeSettings)
      .then(() => {
        window.localStorage.setItem('emailForSignIn', this.state.email);
        window.alert(`Login link sent to ${this.state.email}.  Please check your email for the link.`);
      })
      .catch((error) => {
        console.error(error);
        window.alert(`Unable to send login link to ${this.state.email}: ${error.code}`);
      })
  }
  /** @method handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @method attemptJWTLogin
   * Attempts to tlog the user in if they came
   * from a JWT containing link.
   */
  attemptJWTLogin() {
    const match = /auth=([^&#]+)/.exec(window.location.href);
    if(match) {
      const token = match[1];
      firebase.auth().signInWithCustomToken(token).then(function(){
        //window.location.search = "";
      }).catch(function(error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.error(errorCode, errorMessage);
      });
    }
  }
  /** @method attemptLogin
    * Attempts to log the user in if they came from
    * a firebase signin link.
    */
  attemptLogin() {
    if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
      // Additional state parameters can also be passed via URL.
      // This can be used to continue the user's intended action before triggering
      // the sign-in operation.
      // Get the email if available. This should be available if the user completes
      // the flow on the same device where they started it.
      var email = window.localStorage.getItem('emailForSignIn');
      if (!email) {
        // User opened the link on a different device. To prevent session fixation
        // attacks, ask the user to provide the associated email again. For example:
        email = window.prompt('Please provide your email for confirmation');
      }
      // The client SDK will parse the code from the link for you.
      firebase.auth().signInWithEmailLink(email, window.location.href)
        .then(function(result) {
          // clear the search and hash string in the address
          window.history.replaceState({}, document.title, "/");
          // You can access the new user via result.user
          this.setState({user: result.user});
          // Additional user info profile not available via:
          // result.additionalUserInfo.profile == null
          // You can check if the user is new or existing:
          // result.additionalUserInfo.isNewUser
        })
        .catch(function(error) {
          window.localStorage.removeItem('emailForSignIn');
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
        });
    }
  }
  /** @method componentDidMount
    * Listens for changes in authentication state
    */
  componentDidMount() {
    firebase.auth().onAuthStateChanged( firebaseUser => {
      this.setState({user: firebaseUser});
      // Store the user data globally
      if(firebaseUser) {
        const uid = firebaseUser.uid;
        firebase.database().ref(`users/${uid}`)
        .on('value', (snapshot) => {
          window.vexpo.user = snapshot.val();
        });
      } else {
        window.vexpo.user = {}
      }
      // Flush any tokens from the search string
      //window.location.search = "";
    });
    this.attemptLogin();
    this.attemptJWTLogin();
  }
  /** @function
   * Requires user to be logged in to view.
   * Otherwise, renders the login.
   */
  render() {
    if(this.state.user){
      return (
        <div>
          {this.props.children}
        </div>
      );
    } else {
      return (
        <div className="login-wrapper">
          <div className="login-panel">
            <div>
              <img src={logo} className="app-logo" alt="logo" />
            </div>
            <div>
              <p>
                You should have been provided a login link
                sent directly to your email address from
                noreply@vexposhows.com.  If you
                cannot find your link, you may request a new
                one:
              </p>
              <div className="input-group">
                <label htmlFor="email">Email</label>
                <input id="email" name="email" type="email"
                  value={this.state.email}
                  onChange={this.handleChange}
                  />
              </div>
              <div className="buttonGroup">
                <button onClick={this.handleLinkRequest}>
                  Request Sign In Link
                  <FontAwesome name="sign-in"/>
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/auth/auth.js